'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var configure = require('../lib/configure.js');
var errCode = require('err-code');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

const createInfo = configure.configure(api => {
  const info = async (name, options = {}) => {
    throw errCode__default["default"](new Error('Not implemented'), 'ERR_NOT_IMPLEMENTED');
  };
  return info;
});

exports.createInfo = createInfo;
